<template>
  <section>
    <Title v-if="title.MonetaryCompensation" :title-name="pageTitle" :title-link="title.MonetaryCompensation.titleLink" />
    <div v-if="pax && !pax.is_expired_mc" class="monetary-wrapper container">
      <div id="monetary-title">
        <ItemOfVouchers
          icon="monetary-compensation"
          color="#bbe35d"
          :label="lang['monetary_compensation_new'].SFS_LANG_ROW_10 || 'Monetary compensation'"
          border
        />
      </div>
      <div v-if="lang && lang.monetary_compensation" id="monetatry-compensation-block">
        <div v-if="InfoPaxMonetary" class="monetary-container">
          <MonetaryCompensationUpdate
            v-if="step == 1"
            :service="service"
            :info-pax-monetary-detail="InfoPaxMonetaryDetail"
            :secret="secret"
          />
          <MonetaryCompensationConfirm
            v-if="step == 2"
            :service="service"
            :info-pax-monetary-detail="InfoPaxMonetaryDetail"
            :secret="secret"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container">
        <div v-if="lang.expire_link" class="mt-3">
          <p>{{ lang.expire_link.SFS_LANG_ROW_10 || 'Link has expired' }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import '@/assets/scss/modules/MonetaryCompensation.scss'
import { mapGetters } from 'vuex'
import Title from '@/components/Title/index'
import ItemOfVouchers from '@/components/ItemOfVouchers/index'
import MonetaryCompensationUpdate from './MonetaryCompensationUpdate'
import MonetaryCompensationConfirm from './MonetaryCompensationConfirm'

export default {
  name: 'MonetaryCompensation',
  components: {
    Title,
    ItemOfVouchers,
    MonetaryCompensationUpdate,
    MonetaryCompensationConfirm
  },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      step: 1,
      service: {},
      InfoPaxMonetaryDetail: {}
    }
  },
  computed: {
    ...mapGetters({
      Services: 'Home/Services',
      InfoPaxMonetary: 'MonetaryCompensation/InfoPaxMonetary',
      MonetaryService: 'Home/monetaryService'
    }),
    pageTitle() {
      const { lang } = this
      return lang && lang.hotel_mobile_new && this.lang.hotel_mobile_new.SFS_LANG_ROW_28
        ? lang.hotel_mobile_new.SFS_LANG_ROW_28
        : 'Home'
    }
  },
  watch: {
    Services: {
      handler() {
        this.checkStep()
      },
      deep: true
    },
    InfoPaxMonetary: {
      handler() {
        this.checkStep()
      },
      deep: true
    }
  },
  created() {
    this.checkStep()
  },
  mounted() {
    this.$store.dispatch('MonetaryCompensation/getDataMoneTary', this.$route.query.monetary_id)
  },
  methods: {
    checkStep() {
      if (this.Services.length == 0) {
        this.$store.dispatch('Home/getServices')
      }
      this.service = _.find(this.Services, { service_id: 21 })
      if (!this.service || _.isEmpty(this.service.price_per_person)) {
        return false
      }
      if (this.InfoPaxMonetary && this.InfoPaxMonetary.bank_info) {
        this.InfoPaxMonetaryDetail = this.InfoPaxMonetary
        if (this.InfoPaxMonetary.bank_info && !_.isEmpty(this.InfoPaxMonetary.bank_info.transfer_bank_info)) {
          this.step = 2
        } else {
          this.step = 1
        }
      }
      if (this.MonetaryService) {
        let monetary = _.find(this.MonetaryService.list_monetary, {
          id: parseInt(this.$route.query.monetary_id)
        })
        this.InfoPaxMonetaryDetail.infoCashOrder = _.find(monetary.orders, {
          id: parseInt(this.$route.query.order_id)
        })
        this.InfoPaxMonetaryDetail.currency = monetary.currency
        if (this.InfoPaxMonetary && this.InfoPaxMonetary.monetary_per_person) {
          this.InfoPaxMonetaryDetail.infoCashOrder.amount = this.InfoPaxMonetary.monetary_per_person
        }
      }
    }
  }
}
</script>
